import { Component, Inject, OnInit} from '@angular/core';
import { Store } from '@src/store';
import { userActions } from '@src/store/reducers/userReducer';
import { consts } from '@src/constants/consts';
import { SessionService } from '@src/services';


@Component({
    selector: 'user-management',
    template: require('./usersManagement.html'),
    styles: [require('./_usersManagement.scss')]
})
export class UsersManagementComponent implements OnInit {
    public canManageUsers:boolean;
    
    constructor(@Inject('$state') private $state: any , private store :Store,@Inject('authorizationService') private authorizationService: any , private sessionService:SessionService,) {}

   async ngOnInit() {
    this.sessionService.changeComponent.subscribe(x => {
        console.log(x)
        if(x === 'Users'){
            this.canManageUsers = true;
        }
        else if(x === 'User Groups'){
            this.canManageUsers = false;
        }
    })
    this.store.dispatch({ type: userActions.GET_USER_GROUPS });
    this.store.dispatch({ type: userActions.GET_DOMAINS });
    this.canManageUsers = await this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.AddUser);
    await this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.AddUserGroup);
    if (this.canManageUsers) {
        this.$state.go('app.authorized.usersRolesManagement.usersManagement.users', this.$state.params);
    } else {
        let userGroup = [];
        userGroup.push(this.$state.params.listMenu[1]);
        this.$state.go('app.authorized.usersRolesManagement.usersManagement.usersGroups', userGroup);
    }
   }

//    public ngAfterViewInit() {
//    console.log(this.$state.params)
// }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/usersManagement-ang7.ts